<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CN"><span class="calibre1"> </span></p>
<p class="Text2">A PERMUTED PRESS BOOK</p>
<p class="Text2">Published at Smashwords</p>
<p class="Text2">ISBN (eBook): 978-1-68261-375-7</p>
<p class="Text2"> </p>
<p class="Text2">Martial Law</p>
<p class="Text2">The Journal  Book 6</p>
<p class="Text2"><span xml:lang="ar-SA">© 2017 </span>by Deborah D. Moore</p>
<p class="Text2">All Rights Reserved</p>
<p class="Text2"> </p>
<p class="Text2">Cover art by Christian Bentulan </p>
<p class="Text2"> </p>
<p class="Text2">This book is a work of fiction. People, places, events, and situations are the product of the author’s imagination. Any resemblance to actual persons, living or dead, or historical events, is purely coincidental.</p>
<p class="Text2"> </p>
<p class="Text2">No part of this book may be reproduced, stored in a retrieval system, or transmitted by any means without the written permission of the author and publisher.</p>
<p class="Text2"> </p>
<p class="Text2"><span><img alt="Image15359.JPG" class="frame2" src="Images/Image15359_fmt.jpeg"/></span> </p>
<p class="Text2"> </p>
<p class="Text2"> Permuted Press, LLC</p>
<p class="Text2">109 International Drive, Suite 300</p>
<p class="Text2">Franklin, TN 37067</p>
<p class="Text2">Published in the United States of America<span class="char-style-override1"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// theJournal-1.vue?41a945b3